<template>
    <div class="filter-input" @click="focusInput">
        <div class="filter-input_title mb-1 pt-1 px-3" v-if="label">
            <small>{{ label }}</small>
        </div>
        <div class="filter-input_field px-3 fs-6 pb-2">
            <input ref="inputField" type="text" v-model="value" :placeholder="notSelectedLabel" @input="update" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'FilterInput',
    emits: ['update:modelValue'],
    data() {
        return {
            value: this.modelValue
        }
    },
    props: {
        modelValue: {
            default: null
        },
        notSelectedLabel: {
            type: String,
            default: null
        },
        label: {
            type: String,
            default: null
        }
    },
    methods: {
        update(event) {
            this.$emit('update:modelValue', event.target.value);
        },
        focusInput() {
            this.$refs.inputField.focus();
        }
    },
    watch: {
        modelValue(newVal){
            this.value = newVal
        }
    },
}
</script>

<style scoped>
.filter-input_field input {
    background-color: transparent;
    color: var(--bs-body-color);
}

.filter-input_title {
    color: var(--bs-gray-500);
}

.invalid .filter-input_title{
    color: var(--bs-danger);
}

.filter-input {
    cursor: pointer;
    padding: 1px;
}



.filter-input_field input {
    border: none !important;
    outline: none !important;
    padding: 0;
    width: 100% !important;
}
</style>